export { default } from './dataTable';
